import { gql } from '@apollo/client'

export const magazineIssueEditFragment = gql`
    fragment MagazineIssueEdit on MagazineIssue {
        guid
        url
        canEdit
        statusPublished
        canArchiveAndDelete
        issueNumber
        backgroundColor
        accessId
        timePublished
        scheduleDeleteEntity
        articles {
            __typename @include(if: false)
            guid
            ... on Blog {
                title
            }
        }
        colophon {
            __typename @include(if: false)
            key
            label
            value
        }
    }
`
